import React from 'react';
import { connect } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import {
  Item, Menu, MenuProvider, Separator, Submenu,
} from 'react-contexify';
import { ReactComponent as DownArrow } from '../../assets/svg/down-arrow.svg';
import { ReactComponent as Redmine } from '../../assets/svg/redmine.svg';
import { ReactComponent as RedmineCompleted } from '../../assets/svg/redmine_completed.svg';
import { ReactComponent as Folder } from '../../assets/svg/folder.svg';
import { ReactComponent as FolderCompleted } from '../../assets/svg/folder_completed.svg';
import { ReactComponent as Estimation } from '../../assets/svg/file.svg';
import { ReactComponent as EstimationCompleted } from '../../assets/svg/file_completed.svg';
import 'react-contexify/dist/ReactContexify.min.css';
import {
  setNewDataLead,
  setPopupRedmineActivity,
  setPopupActivity,
  setPopupType,
  setRedmineLink,
  setSelectedLead,
  setTopOffset
} from '../../redux/reduxActions/leadActions';
import { showToastError } from '../utils';
import { ReactComponent as ListSVG } from '../../assets/svg/list.svg';
import copy from 'copy-to-clipboard';
import { toast } from 'react-toastify';
import './event.scss';
const LeadItem = (props) => {
  const {
    data, priorities, selected, proposalTypes, data: { upwork_records }, accountsOwner,
  } = props;
  // console.log(data.upwork_chat_link);
  // console.log(data);
  const setOffsetFromTop = () => {
  	props.setTopOffset(window.scrollY);
  };
  const openDiv = () => {
    const itemRef = document.querySelector(`#itemRef${data.id}`);
    const mainItemRef = document.querySelector(`#mainItemRef${data.id}`);
    const imageRef = document.querySelector(`#imageRef${data.id}`);
    if (itemRef.classList.value.indexOf('lead__item__opened') === -1) {
      itemRef.classList.add('lead__item__opened');
      mainItemRef.classList.add('lead__item__additional_info_opened');
      imageRef.style.transform = 'scaleY(-1)';
    } else {
      imageRef.style.transform = 'scaleY(1)';
      itemRef.classList.remove('lead__item__opened');
      mainItemRef.classList.remove('lead__item__additional_info_opened');
    }
  };
  const getFieldData = (propsElement, itemDataField) => {
    if (!propsElement || !itemDataField) {
      showToastError('getFieldData function params fields are required');
    }
    const fieldData = props[propsElement].find((el) => el.id === data[itemDataField]);
    if (!fieldData) {
      return '-';
    }
    return fieldData.name;
  };
  const setResponsible = () => {
    const type = Object.entries(props.responsible)
      .find((el) => parseInt(el[0], 10) === data.responsible);
    if (!type) {
      return '-';
    }
    return type[1];
  };
  function setLeadCreatedTime() {
    if (data.created_at) {
      return data.created_at.split(' ')[0];
    }
    return '-';
  };
  function typeOfEvent(id) {
    const eventObject = props.eventTypes.find((element) => element.id === id);
    return !!eventObject.title ? eventObject.title : '';
  }

  function CustomArrow() {
    return <img style={{width:"16px",height:"16px"}} src='/images/arrow.svg'/>
  }

  const showLeadData = () => {
    setOffsetFromTop();
    props.history.push(`/lead/${data.id}`);
  };
  function addDataToUpWork() {
	  setOffsetFromTop();
	  props.history.push(`/actions/set-upwork-data/${data.id}`);
  }
  const editLead = () => {
    setOffsetFromTop();
    props.history.push(`/lead/update/${data.id}`);
  };
  function setLeadClassification() {
	  setOffsetFromTop();
	  props.history.push(`/actions/set-lead-classification/${data.id}`);
  }
  function setFirstMessage() {
	  setOffsetFromTop();
	  props.history.push(`/actions/set-first-message/${data.id}`);
  }
  function setGotAnswered() {
    setOffsetFromTop();
    props.history.push(`/actions/got-answered/${data.id}`);
  }
  function setFineDone() {
    setOffsetFromTop();
    props.history.push(`/actions/finedone-lead/${data.id}`);
  }
  function setRawDone() {
    setOffsetFromTop();
    props.history.push(`/actions/rawdone-lead/${data.id}`);
  }
  function closeLead() {
    setOffsetFromTop();
    props.history.push(`/actions/close-lead/${data.id}`);
  }
  function openLead() {
    setOffsetFromTop();
    props.history.push(`/actions/open-lead/${data.id}`);
  }

  function addComment() {
    setOffsetFromTop();
    props.history.push(`/actions/comments-lead/${data.id}`);
  }
  function dealLead() {
    setOffsetFromTop();
    props.history.push(`/actions/deal-lead/${data.id}`);
  }
  function notQualifiedLead() {
    setOffsetFromTop();
    props.history.push(`/actions/not-qualified-lead/${data.id}`);
  }

 /* function setGotAnswerStatus() {
    const selectedStatus = props.funnelStatuses.find((item) => item.name === 'Hot Lead');
    props.setNewDataLead(data.id, { funnel_status: selectedStatus.id }, props.history.push, false);
  }*/

  const setProposalTypes = () => {
    const proposal = proposalTypes.find((item) => item.id === data.proposal_type);
    return proposal ? proposal.name : '-';
  };

  function getFieldDataArray(propsElement, itemDataField) {
    // console.log(itemDataField);
    if (data[itemDataField] !== null
			&& data[itemDataField] !== undefined
			&& props[propsElement] !== null
			&& props[propsElement] !== undefined
			&& data[itemDataField].length
			&& props[propsElement].length) {
      let selectedWorksData = data[itemDataField].map((item) => props[propsElement]
        .find((inner) => item === inner.id));
      selectedWorksData = selectedWorksData.filter((item) => item !== undefined)
        .map((item) => item.name);
      if (Array.isArray(selectedWorksData) && selectedWorksData.length) {
        return selectedWorksData.join(', ');
      }
      return '-';
    }
    return '-';
  }
  function setAccountOwner() {
    if (accountsOwner && upwork_records) {
      const owner = accountsOwner
        .find((item) => item.id === upwork_records.account_owner);
      if (owner) {
      	return owner.account_owner;
      }
    }
    	return '...';
  }
  const contextMenuId = `lead-context-menu-item${data.id}`;

  function setEstimationFile() {
	  const TYPE_OF_POPUP_SETTER_ESTIMATION = false;
	  props.setSelectedLead(data);
    if (!data.estimation_file) {
      setOffsetFromTop();
    	props.setPopupActivity();
      props.setPopupType(TYPE_OF_POPUP_SETTER_ESTIMATION);
    } else {
	    window.open(data.estimation_file, '_blank');
    }
  }

  function setRedmine() {
    // console.log('clicked redmine !');
   // const TYPE_OF_POPUP_SETTER_REDMINE = true;
    if (!data.redmine_link) {
      setOffsetFromTop();
      props.setPopupRedmineActivity();
      props.setSelectedLead(data);
    } else {
      window.open(data.redmine_link, '_blank');
    }
  }

  function setFolder() {
	  const TYPE_OF_POPUP_SETTER_FOLDER = true;
	  if (!data.project_folder) {
      setOffsetFromTop();
		  props.setPopupActivity();
		  props.setSelectedLead(data);
		  props.setPopupType(TYPE_OF_POPUP_SETTER_FOLDER);
	  } else {
		  window.open(data.project_folder, '_blank');
	  }
  }
  return (
    <>
      <MenuProvider
        className="lead__container__items"
        id={window.location.pathname === '/lead-list' ? contextMenuId : 'contextMenuId'}
      >
        <div className="lead_title">
          <a
            href={`/lead/${data.id}`}
            style={{
						  marginRight: 7,
						  color: 'black',
						  textDecoration: 'underline',
						  cursor: 'pointer',
						  fontSize: 15,
            }}
          >
            {data.id}
          </a>
          <p className="estimated-time" style={{ maxWidth: 'calc(100% - 80px)', paddingRight: 10 }}>
            <span>Subject:</span>
            {data.title || '-'}
          </p>
          <p className="estimated-time" style={{ width: 'max-content', position: 'relative', right: -20 }}>
            <span>{data.status ? 'Open' : 'Closed'}</span>
          </p>
        </div>
        <div
          className={`lead__item ${selected ? 'lead__item__additional_info_opened' : ''}`}
          id={`mainItemRef${data.id}`}
        >
          <div style={{
					  display: 'flex', flexWrap: 'wrap', justifyContent: 'inherit', width: '100%',
          }}
          >
            <div className="lead_item__inner-elements" style={{ maxWidth: 202 }}>
              <div className="lead_item__inner-elements__title">
                <p className="estimated-time">
                  <span style={{ marginLeft: 0 }}>Priority:</span>
                  {priorities[data.priority] || '-'}
                </p>
                <p className="estimated-time">
                  <span style={{ marginLeft: 0 }}>UPD:</span>
                  {data.updated_at}
                </p>
                <p className="estimated-time">
                  <span style={{ marginLeft: 0 }}>Next action :</span>
                  {data.next_action || ''}
                </p>
                <p className="estimated-time">
                  <span style={{ marginLeft: 0 }}>Resp.:</span>
                  {setResponsible()}
                </p>
              </div>
            </div>
            <div className="lead_item__inner-elements">
              <div className="lead_item__half" style={{ display: 'flex' }}>
                <p style={{ fontWeight: 600 }}>Funnel:&#160;</p>
                <p className="estimated-time">{getFieldData('funnelType', 'funnel_type')}</p>
              </div>
              <div className="lead_item__half" style={{ display: 'flex' }}>
                <p style={{ fontWeight: 600 }}>L.Status:&#160;</p>
                <p className="estimated-time">{getFieldData('funnelStatuses', 'funnel_status')}</p>
              </div>
            </div>
            <div className="lead_item__inner-elements" style={{ minWidth: 180 }}>
              <div className="lead_item__half">
                <p style={{ fontWeight: 600 }}>Work type</p>
                <p className="estimated-time">{getFieldDataArray('workType', 'work_type')}</p>
              </div>
              <div className="lead_item__half">
                <p style={{ fontWeight: 600 }}>Work tech</p>
                <p className="estimated-time">{getFieldDataArray('workTech', 'work_technology')}</p>
              </div>
            </div>
            <div style={{display: 'flex'}}>

              <div onClick={setRedmine} className="lead_item__half lead_item__content-redmine">
                {data.redmine_link ? <RedmineCompleted /> : <Redmine /> }
              </div>

              <div>

                <div onClick={setFolder} className="lead_item__half lead_item__content-redmine">
                  {data.project_folder ? <FolderCompleted /> : <Folder />}
                </div>

                <div onClick={setEstimationFile} className="lead_item__half lead_item__content-redmine">
                  {data.estimation_file ? <EstimationCompleted /> : <Estimation />}
                </div>

              </div>

            </div>
          </div>
          {/* eslint-disable-next-line react/button-has-type */}
          <button
            onClick={() => {
						  openDiv();
            }}
            className="lead_item__inner-elements lead_item__inner-elements__arrow"
          >
            <DownArrow
              style={{ transition: '.3s' }}
              id={`imageRef${data.id}`}
              className="down-arrow"
            />
          </button>
        </div>

        {/* ----- */}
        <div
          id={`itemRef${data.id}`}
          className={`lead__item lead__item__additional_info ${selected ? 'lead__item__opened' : ''}`}
        >
          <div className="additional_info__main_fields" style={{ justifyContent: 'space-between', flexWrap: 'wrap' }}>
            <div style={{
						  display: 'flex',
            }}
            >
              <span style={{ fontWeight: 600, width: 120, height: '100%' }}>Proposal type:</span>
              <p style={{ maxWidth: 400 }}>{setProposalTypes()}</p>
            </div>
            <div style={{
						  display: 'flex',
            }}
            >
              <span style={{ fontWeight: 600, width: 60, height: '100%' }}>Create:</span>
              <p style={{ maxWidth: 400 }}>{setLeadCreatedTime()}</p>
            </div>
            <div>
              <Button
                onClick={() => editLead()}
                size="sm"
              >
								Update
              </Button>
            </div>
          </div>
          <div className="additional_info__main_fields">
            <div style={{ width: '100%' }}>
              <div style={{
                width: '100%', paddingBottom: 10, marginBottom: 5, borderBottom: 'solid 1px rgb(241, 241, 241)',
              }}
              >
                <span style={{ fontWeight: 600, width: 90, height: '100%' }}>Description:</span>
                <p className="additional_info__main_fields__text">
                  {data.comment || '...'}
                </p>
              </div>
              <div style={{ width: '100%' }}>
                <span style={{ fontWeight: 600, width: 90, height: '100%' }}>First Message:</span>
                <p className="additional_info__main_fields__text" style={{ wordWrap: 'break-word' }}>
                  {data.first_message ? data.first_message.text : '...'}
                </p>
              </div>
              {
		            data.redmine_link
			            ? (
  <div style={{ width: '100%' }}>
    <span style={{ fontWeight: 600, width: 90, height: '100%' }}>Redmine Link:   </span>
    <a href={data.redmine_link} target="_blank" className="additional_info__main_fields__text" style={{ wordWrap: 'break-word' }}>
      {data.redmine_link ? data.redmine_link : '...'}
    </a>
  </div>
		              ) : null
	            }
            </div>
          </div>
          {
	          upwork_records
	          && (
<div className="additional_info__main_fields" style={{ marginTop: 15, borderTop: '1px gray solid', paddingTop: 15, flexDirection: 'column' }}>
  <div style={{ width: '100%' }}>
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>

      <div style={{ display: 'flex' }}>
        <a
          href={`https://www.upwork.com/jobs/~${upwork_records.job_id || ''}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span style={{ fontWeight: 600, marginRight: 7, height: '100%' }}>Job ID:</span>
        </a>
        <p className="additional_info__main_fields__text" style={{ wordWrap: 'break-word', width: 'max-content' }}>
          {upwork_records.job_id || '...'}
        </p>
      </div>
      <div>
        <a
          href={data.upwork_chat_link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span style={{ fontWeight: 600, marginRight: 7, height: '100%' }}>UpWork Chat Link</span>
        </a>
      </div>
      <div style={{ display: 'flex' }}>
        <span style={{ fontWeight: 600, marginRight: 7, height: '100%' }}>Account owner:</span>
        <p className="additional_info__main_fields__text" style={{ wordWrap: 'break-word', width: 'max-content' }}>
          {setAccountOwner()}
        </p>
      </div>
      <div style={{ display: 'flex' }}>
        <span style={{ fontWeight: 600, marginRight: 7, height: '100%' }}>Agency:</span>
        <Form.Group controlId="formBasicCheckbox" className="additional_info__main_fields__text" style={{ wordWrap: 'break-word', width: 'max-content' }}>
          <Form.Check checked={upwork_records.agency || false} disabled type="checkbox" />
        </Form.Group>
      </div>
      {
		    upwork_records.invite_link && (
			    <div>
  <a
    href={upwork_records.invite_link}
    target="_blank"
    rel="noopener noreferrer"
  >
    <span style={{ fontWeight: 600, height: '100%' }}>
			      Invite link from e-mail
    </span>
  </a>
  <ListSVG
    onClick={() => {
						    copy(upwork_records.invite_link);
						    toast.success('Copy successfully!', {
							    position: toast.POSITION.TOP_RIGHT,
							    autoClose: 1000,
						    });
					    }}
    style={{
						    cursor: 'pointer',
						    position: 'relative',
						    top: -1,
						    marginLeft: 5,
					    }}
    width="15"
  />
			    </div>
		    )
	    }
    </div>
  </div>
</div>
	          )
	        }
          {
            data && data.events
            && (
            <div className="events__wrapper">
              {data.events.map((event) => (
                <div className="events__item" key={event.id}>
                  <div className="event-item__header">
                    <p>
                      {
                        event.event_type && event.event_type.title && (
                        <span>
                          {event.event_type.title}
                        </span>
                        )
                      }
                      {' by '}
                      {
                        event.responsible && (
                          <span>
                            {event.responsible.name}
                          </span>
                        )
                      }
                    </p>
                    <p className="event-item__date">
                      {
                        event.created_at ? event.created_at.slice(0, 16) : null
                      }
                    </p>
                  </div>
                  {
                    event.comment && (
                      <ul>
                        <li className="event-item__comment">{event.comment}</li>
                      </ul>
                    )
                  }
                </div>
              ))}
            </div>
            )
            }
        </div>
      </MenuProvider>
      <Menu id={window.location.pathname === '/lead-list' ? contextMenuId : 'contextMenuId'}>
        <Item onClick={showLeadData}>View</Item>
        <Item onClick={editLead}>Edit</Item>
        <Separator />
        <Submenu label="Actions" arrow={<CustomArrow/>}>
          <Item onClick={addDataToUpWork}>Add UpWork Data</Item>
          <Item onClick={setLeadClassification}>
						Lead Classification
          </Item>
            <Item onClick={setFirstMessage}>
          {data.first_message ? 'Edit first message' : 'First message'}
            </Item>
          {(data.funnel_status === 3 ||
            data.funnel_status === 4 ||
            data.funnel_status === 5 ||
            data.funnel_status === 6 ||
            data.funnel_status === 7 ||
            data.funnel_status === 11 ||
            data.funnel_status === 14 ||
            data.funnel_status === 15) ? <Item onClick={setGotAnswered}>Got Answered</Item> : null}
          <Item onClick={setFineDone}>Fine Done</Item>
          <Item onClick={setRawDone}>Defined Needs, Raw Done</Item>
          <Item onClick={data.status ? closeLead : openLead}>
            {data.status ? 'Close Lead (Lost)' : 'Open Lead'}
          </Item>
          <Item onClick={addComment}>
		        Comment
          </Item>
          <Item onClick={dealLead}>
		        Deal (Win)
          </Item>
          <Item onClick={notQualifiedLead}>
          Not Qualified
          </Item>
        </Submenu>
      </Menu>
    </>
  );
};
export default connect((state) => ({
  priorities: state.skillsReducer.priorities,
  funnelStatuses: state.leadReducer.funnelStatuses,
  funnelType: state.leadReducer.funnelType,
  workType: state.leadReducer.workType,
  workTech: state.leadReducer.workTech,
  responsible: state.leadReducer.responsible,
  proposalTypes: state.leadReducer.proposalTypes,
  accountsOwner: state.leadReducer.accountsOwner,
  eventTypes: state.planReducer.eventTypes,
}), {
  setNewDataLead, setTopOffset, setPopupActivity, setPopupRedmineActivity, setRedmineLink, setPopupType, setSelectedLead,
})(LeadItem);
